Ext.define('SA.view.TableTrackContentSizes', {
    constructor({rowHeights, colWidths}) {
        this.rowHeights = rowHeights;
        this.colWidths = colWidths;
    },

    getColWidth({colId}) {
        return this.colWidths[colId];
    },

    getRowHeight({rowId}) {
        return this.rowHeights[rowId];
    }
});